import { Typography } from '@mui/material';
import React from 'react';


interface ITrayMenuItemTextProps {
  label: string;
  description?: string;
}

export const TrayMenuItemText: React.FC<ITrayMenuItemTextProps> = ({ label, description }) => (
  <>
    <Typography
      variant="bodyDefault"
      component="span"
      sx={{ color: 'text.primary', textWrap: 'wrap', lineHeight: '1.25rem' }}
    >
      {label}
    </Typography>
    {description && (
      <Typography
        variant="bodySmall"
        component="span"
        sx={{ color: 'text.secondary', textWrap: 'wrap', lineHeight: '1.25rem' }}
      >
        {description}
      </Typography>
    )}
  </>
);
